import { css, keyframes } from 'emotion';

export namespace styles {
  export const spinAnimation = keyframes({
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  });

  export const loader = css({
    height: 32,
    width: 32,
    border: `2px solid rgba(0, 0, 0, 0.1)`,
    borderTopColor: 'black',
    borderRadius: '50%',
    animation: `${spinAnimation} 1.5s ease infinite`
  });
}
